export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/mascot_cartoon.33cda1f.svg";